/**
 * Human-readable label for who holds the SDTestApp Production run lock.
 * Engine keys are `profile:<browserProfileId>` (NiceGUI) or `user:<hubUserId>` (Hub).
 */
export function formatProductionRunHolderLabel(input: {
  holderKey?: string | null;
  holderDisplayName?: string | null;
  viewerUserId?: string | null;
  viewerDisplayName?: string | null;
}): string | null {
  const holderKey = String(input.holderKey ?? "").trim();
  const rawDisplay = String(input.holderDisplayName ?? "").trim();
  const viewerUserId = String(input.viewerUserId ?? "").trim();
  const viewerDisplayName = String(input.viewerDisplayName ?? "").trim();

  if (holderKey.startsWith("profile:") || rawDisplay.startsWith("profile:")) {
    return "NiceGUI Production";
  }

  const userPrefix = "user:";
  let holderUserId = "";
  if (holderKey.startsWith(userPrefix)) {
    holderUserId = holderKey.slice(userPrefix.length).trim();
  } else if (rawDisplay.startsWith(userPrefix)) {
    holderUserId = rawDisplay.slice(userPrefix.length).trim();
  }

  if (holderUserId && viewerUserId && holderUserId === viewerUserId) {
    return viewerDisplayName || "You";
  }

  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (rawDisplay && !rawDisplay.startsWith(userPrefix) && !uuidPattern.test(rawDisplay)) {
    return rawDisplay;
  }

  if (holderUserId || uuidPattern.test(rawDisplay) || rawDisplay.startsWith(userPrefix)) {
    return "Another Hub operator";
  }

  return rawDisplay || null;
}
